












































import { Component, Vue } from "vue-property-decorator";
import Rooms from "@/sample/rooms.json";
import IconHeading from "@/components/heading/IconHeading.vue";
import TableComponent from "@/components/table/TableComponent.vue";
import RoomTable from "@/containers/RoomTable.vue";
import RoomTableBattery from "@/containers/RoomTableBattery.vue";

@Component({
  components: {
    IconHeading,
    TableComponent,
    RoomTable,
    RoomTableBattery
  }
})
export default class Home_b extends Vue {
  room = Rooms;
}
